// Receive stock asks about a rate only when it looks wrong (docs/plans/free-goods.md): a rate
// under half or over double the product's saved cost. Both are per the unit stock is counted in.

export function rateLooksOff(ratePaisa: number, savedPaisa: number | null): boolean {
  if (ratePaisa <= 0 || !savedPaisa || savedPaisa <= 0) return false
  return ratePaisa * 2 < savedPaisa || ratePaisa > savedPaisa * 2
}

/** "10 times your saved cost", "2.2 times…", or, for a low rate, "Less than half…". */
export function rateAgainstSaved(ratePaisa: number, savedPaisa: number): string {
  if (ratePaisa < savedPaisa) return 'Less than half your saved cost'
  const times = Math.round((ratePaisa * 10) / savedPaisa) / 10
  return `${times} times your saved cost`
}

/**
 * What each product's saved cost becomes after a delivery: the rate paid, in the stock unit. A rate
 * that looks wrong changes nothing unless the user asked. The bill's last usable line wins.
 */
export function savedCostChanges(
  lines: { productId: string; paid: boolean; ratePaisa: number; off: boolean }[],
  alsoOffRates: boolean,
): Map<string, number> {
  const out = new Map<string, number>()
  for (const l of lines) {
    if (l.paid && l.ratePaisa > 0 && (!l.off || alsoOffRates)) out.set(l.productId, l.ratePaisa)
  }
  return out
}
